/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from 'react';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { ImDropbox } from 'react-icons/im';
import { Teams, Utils } from '../../../../utils/api';
import { SpreadSheet } from '../../../../assets/icons/icons';
import { ARMcontext } from '../../../../utils/context/context';
import { Loader, LargeButton, TableAddPlayers } from '../../../../components';
import { INVALID_TO_SPONSOR, TYPES_INVITATIONS } from '../../../../utils/constants/defaultSponsor';
import { AdBody, AdFooter, AdBodyBulk, AdBulkBody, AdBodyTitle, AdBulkFooter, AdBodyBulkAdvise, AdBodyBulkCenter } from '../../styles';
import { MessagesConstants } from '../../../../utils/constants/messages';
import { KeyObjectBulkUpload } from '../../../../utils/enums/bulkUpload/key-object-bulkupload';

/**
 * upload bulk view
 *
 * @param param.membershipsYearly - Number of sponsor subscription available
 * @param param.membershipsYearlyCount - number of yeraly subscriptions available
 * @param param.membershipsYearlyTotal - number of total subscriptions (with subscriptions that have been canceled to players)
 * @param param.changeMembershipsYearly - modify the membershipsYearly
 * @param param.handleView - handles the visibility of the add players modal and makes the request to update the manage players table
 * @param param.teamMemo - list of teams
 * @returns returns the view with the form to load the players from the csv or xlsx file and send the invitation
 */
export default ({
  membershipsYearly,
  membershipsYearlyCount,
  membershipsYearlyTotal,
  changeMembershipsYearly,
  handleView,
  teamMemo,
  setLoadingBulk,
}: {
  membershipsYearly: any;
  membershipsYearlyCount: any;
  membershipsYearlyTotal: number;
  changeMembershipsYearly: any;
  handleView: Function;
  teamMemo: any;
  setLoadingBulk: Function;
}) => {
  const spreadsheetRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  const [errorEmails, useErrorEmails] = useState<Array<string>>([]);
  const { HandleToastMessage } = useContext(ARMcontext);
  const [bulk, useBulk] = useState<any>([]);
  const [submitCalled, useSubmitCalled] = useState(false);
  const [validateBulk, useValidateBulk] = useState<Boolean>(false);
  const [errorBulk, useErrorBulk] = useState<Array<any>>([]);
  const [errorBulkInit, useErrorBulkInit] = useState<Boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isValidatingEmails, setValidateEmails] = useState<Boolean>(false);
  const [drop, useDrop] = useState(false);
  const TEAM = new Teams();
  const UTILS = new Utils();
  const pattern = UTILS.GetValidationEmailPattern();
  const inputPattern = UTILS.GetValidationInputPattern();

  useEffect(() => {
    if (validateBulk) {
      if (!errorBulk.length && !errorBulkInit) {
        HandleBulkSubmit();
      } else {
        if (errorBulkInit) {
          HandleToastMessage('Upload new file with the errors fixed', true, 3000, 'error');
        } else {
          let error = errorBulk[0];
          if(error.message){
            HandleToastMessage(`${error.message} for invitation ` + (error.index + 1), true, 4000, 'error');
          } else if (error.invalidToSponsor) {
            HandleToastMessage('Check the invitations', true, 4000, 'error');
          } else {
            HandleToastMessage('Select a valid length for invitation ' + (error.index + 1), true, 4000, 'error');
          }
        }
        useErrorBulk([]);
      }
      useValidateBulk(false);
    }
  }, [validateBulk]);

  function handleDragEnter(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    useDrop(true);
  }

  function handleDragLeave(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    useDrop(false);
  }

  function handleDragOver(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    useDrop(true);
  }

  function handleDrop(event) {
    event.preventDefault();
    useDrop(false);
    if(event?.dataTransfer?.files)
      HandleFiles(event.dataTransfer.files);
  }

  function StartValidationsBulk(): void {
    bulk.forEach((elem, index) => {
      if(elem.message){
        useErrorBulk(prev => [...prev, { message: elem.message, index}]);
      } else if (elem.color === INVALID_TO_SPONSOR) {
        useErrorBulk(prev => [...prev, { invalidToSponsor: true, index: index }]);
      } else if (elem[4].value === TYPES_INVITATIONS.SPONSOR_PLAYER) {
        if (!elem[6]) {
          useErrorBulk(prev => [...prev, { index: index }]);
        }
      }
    });
    useValidateBulk(true);
  }

  function HandleTemplate(): void {
    window.open('https://armcare-templates.s3.amazonaws.com/bulk-upload-invitations.csv', '_blank');
  }

  function UploadSpreadsheet(): void {
    spreadsheetRef.current.click();
    spreadsheetRef.current.onchange = () => {
      HandleFiles(spreadsheetRef.current.files);
    };
  }

  function HandleFiles(imported: Array<File>) {
    if(!imported)
      return HandleToastMessage('Please upload a valid file', true, 2500, 'error')
    if (imported[0]?.name?.includes('.csv')) {
      Papa.parse(imported[0], {
        header: true,
        complete: function (results) {
          const duplicates = new Set();
          let parsedData: Array<Array<string>> = [];
          let errorData: Array<string> = [];
          results.data.forEach(item => {
            const keys = Object.keys(item);
            if(!keys.includes(KeyObjectBulkUpload.email) && !keys.includes(KeyObjectBulkUpload.firstName) && !keys.includes(KeyObjectBulkUpload.lastName))
              errorData.push('wrong keys')
            let values = Object.values(item) as string[] | string[][];
            if(values[0].includes(',')) values = (values[0] as string).split(',');
            parsedData.push(values as string[])
          })
          let extracted: Array<Array<string>> = [
            ...parsedData.filter((el: any) => {
              if (el[0] !== '') {
                duplicates.add(el[2]);
              }
              return el[0] !== undefined && el[0] !== '';
            }),
          ];

          // extracted.pop();
          const isValidLength = extracted.every(e => {
            return e.length <= 3
          })
          if(errorData.length > 0)
            return HandleToastMessage(MessagesConstants.BULK_UPLOAD.WRONG_FORMAT, true, 3000, 'warning');
          if(!isValidLength) {
            return HandleToastMessage(MessagesConstants.BULK_UPLOAD.WRONG_FORMAT, true, 3000, 'warning');
          }
          if (extracted.length === 0) {
            return HandleToastMessage(MessagesConstants.BULK_UPLOAD.EMPTY_FILE, true, 3000, 'warning');
          }
          useBulk(extracted);
        },
      });
    } else if (imported[0]?.name?.includes('.xlsx') || imported[0]?.name?.includes('.xls')) {
      const files = imported,
        f = files[0];
      const reader = new FileReader();
      const duplicates = new Set();
      reader.onload = function (e: any) {
        const data = e.target.result;
        const readedData = XLSX.read(data, { type: 'binary' });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];
        const dataParse: string[][] = XLSX.utils.sheet_to_json(ws, { header: 1 });
        let errorData: Array<string> = [];
        dataParse[0].forEach(item => {
          if(!item.includes(KeyObjectBulkUpload.email) && !item.includes(KeyObjectBulkUpload.firstName) && !item.includes(KeyObjectBulkUpload.lastName))
            errorData.push('wrong keys')
        })
        if(errorData.length > 0)
          return HandleToastMessage(MessagesConstants.BULK_UPLOAD.WRONG_FORMAT, true, 3000, 'warning');
        let parsedData: Array<any> = [
          ...dataParse.filter((el: any) => {
            if (el[0] !== '') {
              duplicates.add(el[2]);
            }
            return el[0] !== undefined && el[0] !== '' && el[0] !== KeyObjectBulkUpload.firstName;
          }),
        ];
        if (duplicates.size !== 0) duplicates.delete(parsedData[0][2]);
        const isValidLength = parsedData.every(e => {
          return e.length <= 3
        })
        if(!isValidLength) {
          return HandleToastMessage(MessagesConstants.BULK_UPLOAD.WRONG_FORMAT, true, 3000, 'warning');
        }

        if (dataParse.length === 0) {
          return HandleToastMessage('This file seems to be empty', true, 3000, 'warning');
        }
        useBulk(parsedData);
      };
      reader.readAsBinaryString(f);
    } else {
      HandleToastMessage('This extension is not supported, try with an .csv, .xlsx file', true, 2500, 'warning');
    }
  }

  async function HandleBulkSubmit() {
    const fail = Array<string>();
    const send = Array<any>();
    const mails = new Set(bulk.map(e => e[2].trim()));
    const valid = bulk.filter(el => {
      const email = el[2].trim();
      if (mails.has(email)) {
        mails.delete(email);
        return true;
      }
      return false;
    });
    valid.map(el => {
      const teams = el[3]?.filter(team => team !== undefined);
      const build = {
        firstName: el[0],
        lastName: el[1],
        email: el[2].trim(),
        requestType: el[4].type,
        block: el[6],
        team: teams,
        onboarding: false,
      };


      if (!Boolean(inputPattern.test(el[0]))) {
        fail.push(MessagesConstants.BULK_UPLOAD.INVALID_FORMAT_NAME(el[0]));
      } else if(!Boolean(inputPattern.test(el[1]))){
        fail.push(MessagesConstants.BULK_UPLOAD.INVALID_FORMAT_LAST_NAME(el[1]));
      } else if(!Boolean(pattern.test(el[2].trim()))) {
        fail.push(MessagesConstants.BULK_UPLOAD.INVALID_FORMAT_EMAIL(el[2]));
      } else {
        send.push(build);
      }
      return build;
    });
    if(fail.length > 0){
      return HandleToastMessage(fail.join('\n'), true, 4000, 'error');
    }

    if (send.length > 0) {
      if (submitCalled === false) {
        useSubmitCalled(true);
        setLoadingBulk(true);
        const result = await TEAM.InviteByBulkUpload(send);
        if (result.status) {
          useSubmitCalled(false);
          if (result.data.statusCode === 201) {
            HandleToastMessage(result.data.message, true, 4500, 'success');
            handleView(false, true);
          } else {
            HandleToastMessage('One or more players already registered', true, 4000, 'error');
            const errorEmails: Array<string> = [];
            result.data.errorMessages.map((el: string) => {
              const errowed = el.split(' ')[3];
              const result = valid.filter(il => {
                return il[2].toLowerCase() === errowed;
              });
              errorEmails.push(result[0]);
              return result[0];
            });
            useErrorEmails([...errorEmails]);
            setLoadingBulk(false);
          }
        } else {
          useSubmitCalled(false);
          setLoadingBulk(false);
          HandleToastMessage(result.data?.message || 'Invitation not sent', true, 4000, 'error');
        }
      }
    } else {
      HandleToastMessage('invalid data for one or more players', true, 4000, 'error');
    }
  }

  return (
    <div data-cy="bulk_upload_form">
      <AdBody>
        {!Boolean(bulk.length) ? (
          <>
            <div>
              <AdBodyTitle>Players</AdBodyTitle>
            </div>
            {isValidatingEmails ? (<Loader height="283px" />) : (
              <AdBodyBulk
                dropZone={drop}
                data-cy="input_bulk"
                onClick={UploadSpreadsheet}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  ref={spreadsheetRef}
                  type="file"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  style={{ display: 'none' }}
                />
                <AdBodyBulkAdvise>
                  {drop ? (
                    <>
                      <ImDropbox color="#5D6E81" size="93px" />
                      <AdBodyBulkCenter>Drop it !</AdBodyBulkCenter>
                    </>
                  ) : (
                    <>
                      <SpreadSheet />
                      <AdBodyBulkCenter>Upload spreadsheet</AdBodyBulkCenter>
                    </>
                  )}
                </AdBodyBulkAdvise>
              </AdBodyBulk>
            )}
          </>
        ) : (
          <>
            <AdBulkBody>
              <TableAddPlayers
                dataTableContent={bulk}
                teamMemo={teamMemo}
                errorData={errorEmails}
                updateTableContent={useBulk}
                membershipsYearly={membershipsYearly}
                membershipsYearlyCount={membershipsYearlyCount}
                membershipsYearlyTotal={membershipsYearlyTotal}
                changeMembershipsYearly={changeMembershipsYearly}
                changeErrorBulkInit={useErrorBulkInit}
              />
            </AdBulkBody>
          </>
        )}
      </AdBody>
      {!Boolean(bulk.length) ? (
        <AdBulkFooter>
          <LargeButton
            callback={() => handleView(false)}
            rColor="#ffffff"
            lColor="#ffffff"
            title="CANCEL"
            fColor="#5D6C76"
            bColor="#F0F0F0"
            lMargin="0"
            rMargin="0 40px"
            xMargin="0 10px 0 0"
          />
          <LargeButton callback={HandleTemplate} rColor="#207245" lColor="#1A643C" icon="excel" title="DOWNLOAD TEMPLATE" />
        </AdBulkFooter>
      ) : (
        <AdFooter>
          <LargeButton
            callback={() => handleView(false)}
            rColor="#ffffff"
            lColor="#ffffff"
            title="CANCEL"
            fColor="#5D6C76"
            bColor="#F0F0F0"
            lMargin="0"
            rMargin="0 40px"
            xMargin="0 10px 0 0"
          />
          {submitCalled ? (
            <Loader width="186px" />
          ) : (
            <LargeButton callback={StartValidationsBulk} rColor="#007AFF" lColor="#006BE1" icon="done" title="ADD / SEND INVITE" />
          )}
        </AdFooter>
      )}
    </div>
  );
};
